import { useCallback, useEffect, useState } from "react";
import { Alert, Button, Form, Select, Spin } from "antd";
import { TypeParams } from "../../../types";
import { makeApiRequest } from "../../../lib/api";
import { defaultLinkAftercare } from "../../../lib/config";
import { useTranslation } from "react-i18next"; // Import useTranslation hook

const { Option } = Select;

interface EgwAnpassungForm1PlaceProps {
  commitCurrentPlace: (placeId: number | null) => void;
  params: TypeParams; // Define the type of the ccid prop
}

const EgwAnpassungForm1Place: React.FC<EgwAnpassungForm1PlaceProps> = ({ commitCurrentPlace, params }) => {
  const { t } = useTranslation(); // Initialize the translation hook
  const [error, setError] = useState("");
  const [form] = Form.useForm();
  const [places, setPlaces] = useState<null | []>(null);
  const linkAftercare = params.linkAftercare ? params.linkAftercare : defaultLinkAftercare;

  // FORM 1 SUBMIT: send email or phone number to validate
  const onLoadForm1 = useCallback(async () => {
    setError("");
    commitCurrentPlace(null);
    try {
      let action = "";
      let content: any = {};
      action = "REACT_GET_AFTERCARE_PLACES";
      content = {};
      const response = (await makeApiRequest(params, action, content)) as any;
      const parsed = JSON.parse(response);
      if (!parsed || parsed.STATUS !== "OK") {
        setError(t('kontrolltermin.places.error'));
      } else {
        if (parsed.MESSAGE !== "OK") {
          setError(t('kontrolltermin.places.loadError'));
        } else {
          setPlaces(parsed.CONTENT);
        }
      }
    } catch (error) {
      setError(t('kontrolltermin.places.error'));
    }
  }, [commitCurrentPlace, params, t]);

  const onFinishFailed = async () => {
    setError(t('kontrolltermin.places.formIncomplete'));
  };

  const onFinishForm1 = async () => {
    setError(""); // Clear previous errors

    const placeId = form.getFieldValue("place_id");

    if (!placeId) {
      setError(t('kontrolltermin.places.noPlaceSelected'));
      return;
    }
    // console.log("Redirecting to aftercare page", form.getFieldValue("existingcustomer"), linkAftercare);

    if (form.getFieldValue("existingcustomer") === "existing") {
      // Redirect to another http page
      window.location.href = linkAftercare;
    }

    commitCurrentPlace(placeId);
  };

  // INIT
  useEffect(() => {
    onLoadForm1();
  }, [onLoadForm1]);

  if (!places) {
    return (
      <div className={"my-lg"}>
        <Spin />
      </div>
    );
  }

  return (
    <>
      <p className={"my-md"}>
        <strong>{t("kontrolltermin.places.title")}</strong>
      </p>
      {error && <Alert message={error} />}

      <p>{t("kontrolltermin.places.description")}</p>

      <div className={"my-lg"}>
        <Form
          name="basic"
          form={form}
          wrapperCol={{ span: 16 }}
          onFinish={onFinishForm1}
          onFinishFailed={onFinishFailed}
          style={{ maxWidth: 600 }}
          autoComplete="off"
        >
          <Form.Item
            label={t("kontrolltermin.places.selectLabel")}
            name="place_id"
            rules={[{ required: true, message: t("kontrolltermin.places.selectError") }]}
          >
            <Select placeholder={t("kontrolltermin.places.selectPlaceholder")} loading={places === null || places === undefined}>
              {places.map((place: any) => (
                <Option key={place.id} value={place.id}>
                  {place.name}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item wrapperCol={{ offset: 20, span: 16 }}>
            <Button type="primary" htmlType="submit">
              {t("kontrolltermin.places.submitButton")}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </>
  );
};

export default EgwAnpassungForm1Place;
